import Cookie from "../helper/cookie";
import JSONParser from "../helper/json-parser";
import WindowManager from "../components/window-manager";

const TYPES = {
    cookie: writeToCookie,
    local: writeToLocalStorage,
    functionId: writeFunctionIdToStorage
};

function initialize(element) {
    const storageConfig = JSONParser.tryParseJSON(element.getAttribute(`jsh-storage`));
    const modes = storageConfig.modes || ["mousedown"];

    modes.forEach(function(mode) {
        if(mode === "immediate") {
            bindTypes(element, mode, storageConfig);
            return;
        }
        element.addEventListener(mode, (e) => {
            bindTypes(e.target, mode, storageConfig);
        });
    });
}

export default {
    initialize
};

function bindTypes(element, mode, storageConfig) {
    const types = storageConfig.types || ["cookie", "local"];
    types.forEach(function(type) {
        TYPES[type](storageConfig);
    });
    element.removeEventListener(mode, bindTypes);
}

function writeToLocalStorage(storageConfig) {
    localStorage.setItem(storageConfig.name, storageConfig.value);
}

function writeFunctionIdToStorage(storageConfig) {
    WindowManager.setSpecificTabDataItem(storageConfig.name, storageConfig.value);
}

function writeToCookie(storageConfig) {
    const options = {
        domainOverride: storageConfig.domainOverride,
        expires: storageConfig.expires,
        path: storageConfig.path,
        raw: storageConfig.raw
    };
    Cookie.set(storageConfig.name, storageConfig.value, options);
}
